import { render, staticRenderFns } from "./ASelfAssessmentResultExpansion.vue?vue&type=template&id=74adf6b2&scoped=true&"
import script from "./ASelfAssessmentResultExpansion.vue?vue&type=script&lang=ts&"
export * from "./ASelfAssessmentResultExpansion.vue?vue&type=script&lang=ts&"
import style0 from "./ASelfAssessmentResultExpansion.vue?vue&type=style&index=0&id=74adf6b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74adf6b2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VExpansionPanel,VExpansionPanelContent,VExpansionPanelHeader,VExpansionPanels,VIcon})
